import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { font, color, mediaQuery } = baseVariables;

export const StyledCalendar = styled.div`
  .DayPicker {
    width: 100%;

    .DayPicker-wrapper {
      width: 100%;
      padding: ${toRem(16)} 0;
      border-top: 1px solid ${color.neutral20};

      .DayPicker-Months {
        .DayPicker-Month {
          margin-left: 0;
          margin-right: 0;
          width: 100%;

          & ~ .DayPicker-Month {
            margin-left: 0;
            margin-right: 0;
          }

          @media ${mediaQuery.lg} {
            width: ${toRem(310)};
            margin-top: 0;
            margin-right: ${toRem(16)};
            height: 100%;

            & ~ .DayPicker-Month {
              margin-left: ${toRem(16)};
              margin-top: 0;
            }
          }

          .DayPicker-Weekdays {
            .DayPicker-Weekday {
              color: ${color.base10};
              font-family: ${font.fontFamilySwiss};
            }
          }

          .DayPicker-Body {
            .DayPicker-Week {
              .DayPicker-Day {
                .DayPicker-Day-Cell {
                  width: ${toRem(44)};
                  height: ${toRem(44)};
                }

                &.DayPicker-Day--disabled {
                  .DayPicker-Day-Cell {
                    .DayPicker-Day-value {
                      color: ${color.neutral30};
                    }
                  }
                }
              }
            }
          }

          .DayPicker-Caption {
            margin-bottom: ${toRem(18)};
            padding-top: ${toRem(4)};
            width: 100%;
            & > div {
              text-transform: capitalize;
              color: ${color.base10};
              font-size: ${font.fontM};
              font-weight: ${font.fontWeightRegular};
              letter-spacing: ${toRem(1.3)};
              line-height: ${toRem(12)};
              text-align: left;
              @media ${mediaQuery.md} {
                text-align: center;
              }
            }
          }
        }
      }

      .DayPicker-NavBar {
        display: none;
        @media ${mediaQuery.md} {
          display: block;
        }
        
        .DayPicker-NavButton {
          z-index: 1;
          &.DayPicker-NavButton--next {
            right: ${toRem(2)};
            top: ${toRem(-2)};
            &:before {
              line-height: ${toRem(20)};
            }
          }
          &.DayPicker-NavButton--prev {
            left: ${toRem(-2)};
            top: ${toRem(-2)};
            &:before {
              line-height: ${toRem(20)};
            }
          }
        }
      }
    }
  }

  .DayPicker-Weekday abbr[title] {
    font-weight: ${font.fontWeightRegular};
    letter-spacing: 0;
    line-height: ${toRem(16)};
    color: ${color.neutral40};
  }
`;
